import { IntegrationSystem } from '@/shared/types';

import { ARS_ROUTES } from '@/modules/ars/routes/config';
import { BIA_ROUTES } from '@/modules/bia/routes/config';
import { ERZ_ROUTES } from '@/modules/erz/routes/config';
import { IAC_ROUTES } from '@/modules/iac/routes/config';
import { PAY_ROUTES } from '@/modules/pay/routes/config';
import { RMP_ROUTES } from '@/modules/rmp/routes/config';
import { RMPC_ROUTES } from '@/modules/rmpc/routes/config';
import { WNT_ROUTES } from '@/modules/wnt/routes/config';

import { RouteConfig, RoutesBySystem } from './types';
import { createRoutesObject } from './utils/createRoutesObject';

export { ROUTES } from './baseRoutes';

interface BinotelChatInstance {
  open?: () => void;
  widgetId?: string | number;
  initState?: string | boolean;
}

declare global {
  interface Window {
    onRouterLoaded?: (cfg: RoutesInputType) => void;
    BinotelChat?: Record<string, BinotelChatInstance>;
  }
}

export const GENERAL_ROUTES = {
  HOME: { basePath: '', path: '/', isPrivate: false },
  LOGIN: { basePath: '', path: '/login', isPrivate: false },
  INTERNAL_SERVICES: { basePath: '', path: '/services', isPrivate: false },
  EXTERNAL_SERVICES: { basePath: '', path: '/external-services', isPrivate: false },
  PERSONAL_DATA: { basePath: '', path: '/personal_data', isPrivate: false },
  GERC_REDIRECT: { basePath: '', path: '/gerc_redirect', isPrivate: false, isServiceRoute: true },
  DIIA_REDIRECT: { basePath: '', path: '/diia_redirect', isPrivate: false, isServiceRoute: true },
  USER_PROFILE: { basePath: 'user', path: 'profile', isPrivate: true },
  USER_REQUESTS_ACTIVE: {
    basePath: 'user',
    path: 'requests/active',
    isPrivate: true,
  },
  USER_REQUESTS_ARCHIVED: {
    basePath: 'user',
    path: 'requests/archived',
    isPrivate: true,
  },
  USER_REQUESTS_DRAFT: {
    basePath: 'user',
    path: 'requests/draft',
    isPrivate: true,
  },
  NEWS: {
    basePath: '',
    path: 'news',
    isPrivate: true,
  },
};

export type RoutesInputType = {
  [S in IntegrationSystem]?: RoutesBySystem<S>;
} & {
  GENERAL: Record<keyof typeof GENERAL_ROUTES, RouteConfig>;
};

export const ROUTES_INPUT: RoutesInputType = {
  [IntegrationSystem.ERZ]: ERZ_ROUTES,
  [IntegrationSystem.IAC]: IAC_ROUTES,
  [IntegrationSystem.RMP]: RMP_ROUTES,
  [IntegrationSystem.BIA]: BIA_ROUTES,
  [IntegrationSystem.PAY]: PAY_ROUTES,
  [IntegrationSystem.ARS]: ARS_ROUTES,
  [IntegrationSystem.WNT]: WNT_ROUTES,
  [IntegrationSystem.RMPC]: RMPC_ROUTES,
  GENERAL: GENERAL_ROUTES,
};

import.meta.env.DEV && window.onRouterLoaded && window.onRouterLoaded(ROUTES_INPUT);

export const { ROUTES_BY_SERVICE_CODE, OTHER_ROUTES } = createRoutesObject(ROUTES_INPUT);
